import script from "./gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./gallery.vue?vue&type=script&setup=true&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=21ca354c&lang=scss&scoped=true"
script.__scopeId = "data-v-21ca354c"

export default script